import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, vShow as _vShow, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-e0a7ccbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Detalles de Usuario")
], -1))
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos Generales")
], -1))
const _hoisted_8 = { class: "grid" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "email"
}, "Email:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "role"
}, "Rol:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Administrador", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Encargado", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Agente", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Especialista", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Encargado de Cuentas Médicas", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Facturador", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Médico Especialista", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Director Médico", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "Recepcionista", -1))
const _hoisted_20 = [
  _hoisted_11,
  _hoisted_12,
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17,
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "role"
}, "Estatus por Defecto:", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "1 - Recibido por Auditoría Interna", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "4 - Recibido por Reclamaciones Médicas", -1))
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "grupo"
}, "Grupo:", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "nombre"
}, "Nombre:", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "puedeVer"
}, "Puede Ver:", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "ta-l col-form-label col-form-label-sm",
  for: "aseguradoras"
}, "Aseguradoras:", -1))
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<option value=\"5\" data-v-e0a7ccbc>ARS CMD</option><option value=\"14\" data-v-e0a7ccbc>MAPFRE SALUD ARS, S.A.</option><option value=\"8\" data-v-e0a7ccbc>FUTURO</option><option value=\"12\" data-v-e0a7ccbc>META SALUD</option><option value=\"23\" data-v-e0a7ccbc>YUNEN</option><option value=\"17\" data-v-e0a7ccbc>RESERVAS</option><option value=\"13\" data-v-e0a7ccbc>MONUMENTAL</option><option value=\"4\" data-v-e0a7ccbc>ASEMAP</option><option value=\"1\" data-v-e0a7ccbc>ARS APS S A</option><option value=\"21\" data-v-e0a7ccbc>SIMAG</option><option value=\"16\" data-v-e0a7ccbc>RENACER</option><option value=\"59\" data-v-e0a7ccbc>GRUPO MEDICO ASOCIADO</option><option value=\"24\" data-v-e0a7ccbc>PRIMERA ARS DE HUMANO</option><option value=\"22\" data-v-e0a7ccbc>UNIVERSAL</option><option value=\"29\" data-v-e0a7ccbc>ALBA GAS S.R.L.</option><option value=\"10\" data-v-e0a7ccbc>HUMANO SEGUROS</option><option value=\"20\" data-v-e0a7ccbc>SENASA CONTRIBUTIVO</option><option value=\"61\" data-v-e0a7ccbc>SENASA SUBSIDIADO</option><option value=\"18\" data-v-e0a7ccbc>SEMMA</option><option value=\"65\" data-v-e0a7ccbc>IDOPPRIL</option>", 20)
const _hoisted_49 = [
  _hoisted_29
]
const _hoisted_50 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    (_ctx.cargando)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", null, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  type: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentUsuario.email) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.currentUsuario.email]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_10,
                _withDirectives(_createElementVNode("select", {
                  id: "role",
                  type: "role",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentUsuario.role) = $event)),
                  class: "form-select"
                }, _hoisted_20, 512), [
                  [_vModelSelect, _ctx.currentUsuario.role]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_21,
                _withDirectives(_createElementVNode("select", {
                  id: "role",
                  type: "role",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentUsuario.defaultStatus) = $event)),
                  class: "form-select"
                }, _hoisted_24, 512), [
                  [_vModelSelect, _ctx.currentUsuario.defaultStatus]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_25,
                _withDirectives(_createElementVNode("select", {
                  id: "grupo",
                  type: "grupo",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currentUsuario.grupo) = $event)),
                  class: "form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usuarios, (usuario, index) => {
                    return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(usuario.nombre), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.currentUsuario.grupo]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  id: "nombre",
                  type: "nombre",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.currentUsuario.nombre) = $event)),
                  class: "form-control"
                }, null, 512), [
                  [_vModelText, _ctx.currentUsuario.nombre]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_27,
                _withDirectives(_createElementVNode("select", {
                  id: "puedeVer",
                  multiple: "",
                  type: "puedeVer",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.currentUsuario.puedeVer) = $event)),
                  class: "form-select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usuarios, (usuario, index) => {
                    return (_openBlock(), _createElementBlock("option", { key: index }, _toDisplayString(usuario.nombre), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.currentUsuario.puedeVer]
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_28,
                _withDirectives(_createElementVNode("select", {
                  id: "aseguradoras",
                  multiple: "",
                  type: "aseguradoras",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentUsuario.aseguradoras) = $event)),
                  class: "form-select"
                }, _hoisted_49, 512), [
                  [_vModelSelect, _ctx.currentUsuario.aseguradoras]
                ])
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.handleUpdate()), ["prevent"])),
            disabled: 
              !_ctx.currentUsuario.email ||
                !_ctx.currentUsuario.password ||
                !_ctx.currentUsuario.role ||
                !_ctx.currentUsuario.nombre ||
                !_ctx.currentUsuario.estatus
            
          }, " Actualizar ", 8, _hoisted_50),
          _createElementVNode("button", {
            class: "btn btn-danger",
            onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.handleDelete()), ["prevent"]))
          }, " Eliminar ")
        ])
      ])
    ], 512), [
      [_vShow, !_ctx.cargando]
    ])
  ]))
}